import {Injectable} from '@angular/core';
import * as globals from '../settings';
import {CookieService} from 'ngx-cookie-service';
import {LotteriesService} from '../lotteries.service';
import {SubscriptionsService} from './subscriptions.service';
import {ActivatedRoute, Router} from '@angular/router';
import {CartService} from './cart.service';
import {Subscription} from 'rxjs';
import {LoginService} from '../shared/navigation/login.service';
import {TimeService} from './time.service';
import {TranslateService} from '@ngx-translate/core';
import {LanguageService} from './language.service';
import {UserService} from './user.service';
import {ActionService} from './action.service';
import {Location} from '@angular/common';
import {SeoService} from './seo.service';
import {CurrencyService} from './currency.service';
import {GetPaymentMethodsService} from '../shared/paymentMethod/get-payment-methods.service';

@Injectable()
export class ParamsService {
    language: string;
    virtualLogin: string;
    userBalance: any;
    virtualLoginSubscription: Subscription;
    userDataNameWithGender: any;
    userDataNameWithGenderSubscription: Subscription;
    loggedIn: any;
    resetToken: string;
    resetEmail: string;
    resetPassword: any;
    showForgetPassword: any;
    modalSize: any;
    timeZone: string;
    packageId: any;
    ticketAmount: any;
    cantRedirect: any;
    cartItem: any;
    changedCurrency: Subscription;
    currency: any;

    constructor(private cookieService: CookieService,
                public lotteryService: LotteriesService,
                private subscriptionsService: SubscriptionsService,
                private router: Router,
                private cartService: CartService,
                private loginService: LoginService,
                private timeService: TimeService,
                private translate: TranslateService,
                private languageService: LanguageService,
                private userService: UserService,
                private actionService: ActionService,
                private activatedRoute: ActivatedRoute,
                private location: Location,
                public currencyService: CurrencyService,
                public getpmService: GetPaymentMethodsService
    ) {
        this.language = 'en';
        const language = localStorage.getItem('pageLanguage');
        if (language !== null) {
            if (language === 'de' || language === 'en') {
                this.language = language;
            } else {
                this.language = 'en';
            }
        }

        this.virtualLoginSubscription = this.subscriptionsService.getVirtualLogin().subscribe(
            virtualLogin => {
                this.virtualLogin = virtualLogin;
            }
        );
        this.userDataNameWithGenderSubscription = this.subscriptionsService.getUserDataNameWithGender().subscribe(data => {
            this.userDataNameWithGender = data;
        });
        this.currency = this.currencyService.currency;
        this.changedCurrency = this.subscriptionsService.getChangeCurrency().subscribe(currency => {
            if (currency) {
                this.currency = currency;
            }
        });
    }

    public checkForParams(params) {
        if (params['mc']) {
            this.cookieService.set('mc', params['mc'], 3);
        }
        if (params['jlpid']) {
            this.cookieService.set('jlpid', params['jlpid'], 3);
        }
        if (params['campaign']) {
            this.cookieService.set('campaign', params['campaign'], 3);
        }
        if (params['referral']) {
            this.cookieService.set('referral', params['referral'], 3);
        } else if (!params['referral'] && !this.cookieService.get('referral')) {
            const url = window.location.origin + '/' + window.location.search;
            this.cookieService.set('referral', url, 3);
        }
        if (params['developerCurrencyCountryCode']) {
            localStorage.setItem('developerCurrencyCountryCode', params['developerCurrencyCountryCode']);
        }
        if (params['incentiveCode']) {
            this.cookieService.set('incentiveCode', params['incentiveCode'], 3);
          // if (this.userService.userData) {
          //   this.userService.sendSomeCookies(params['incentiveCode']);
          // }
        }
        if (params['btag'] || params['btag']) {
            const cookieBtagExists: boolean = this.cookieService.check('btag');
            this.cookieService.delete('btag');
            this.cookieService.set('btag', params['btag'], 3);
        }

        if (params['action'] === 'reload' && params['gid']) {
            setTimeout(() => {
                this.subscriptionsService.emitStartInstant(params['gid']);
            }, 3000);
        }

        if (params['package'] && !params['email'] && !params['email_token']) {
            const DataString = localStorage.getItem('playerDetails');
            const dataJson = JSON.parse(DataString);


            let url;
            const paramsUrl = this.actionService.checkParamsUrl(params['redirectUrl']);
            if (paramsUrl && paramsUrl.length > 1) {
                url = paramsUrl[0].toLowerCase();
                localStorage.setItem('dashboardStatus', paramsUrl[1].toLowerCase());
            } else {
                url = params['redirectUrl'] ? params['redirectUrl'].toLowerCase() : 'home';
            }

            let isGamePackage = false;
            let ticketsDefault;

            this.lotteryService.getLotteries(
                globals.appDomain + '/ScratchCards/getGamePackages/getGamePackages_nav.json').subscribe(
                result => {
                    if (result) {
                        for (let i = 0; i < result.length; i++) {
                            if (result[i].PackageID === params['package']) {
                                isGamePackage = true;
                                ticketsDefault = result[i].ProductType !== 'bundle' ? result[i].PackageMultiTickets[1].Tickets : 1;
                            }
                        }
                    }
                }, (err) => console.error(err),
                () => {

                    if (isGamePackage) {
                        const userDataString = localStorage.getItem('playerDetails');
                        const userDataJson = JSON.parse(userDataString);
                        let memberId = '0';
                        if (userDataJson) {
                            memberId = userDataJson.MemberID;
                        }
                        const packageId = params['package'];
                        const ticketsCount = params['tickets'] ? params['tickets'] : ticketsDefault;
                        let cartToSend = 'packageId=' + packageId + '&ticketsCount=' + ticketsCount;
                        if (userDataJson && userDataJson.sessionId) {
                            cartToSend += '&sessionId=' + userDataJson.sessionId + '&sessionCart=0';
                        } else {
                            cartToSend += '&sessionId=' + '&sessionCart=0';
                        }
                        cartToSend += '&currency=' + this.currency.Code;
                        this.lotteryService
                            .postData(globals.appDomain + '/cart/addSingleTicket/' +
                                memberId + '/cartAddSingleTicket_scratchcard_nav.json', cartToSend)
                            .subscribe(
                                resp => {
                                    if (!resp.addCartMessage.ErrorID && resp.addCartMessage) {
                                        localStorage.setItem('cart', JSON.stringify(resp.addCartMessage.Cart.Packages));
                                        const cart2 = resp.addCartMessage.Cart.Packages;
                                        this.subscriptionsService.updateCartItems(cart2);
                                        this.subscriptionsService.updateCart(0);

                                        url = url.indexOf('/') == 0 ? url.substring(1) : url;
                                        this.router.navigateByUrl('/' + this.language + '/' + url);
                                    }
                                }
                            );


                    } else {
                        let playerShares;
                        if (params['teamplayPackage']) {
                            playerShares = '&playerShares=' + 1;
                            localStorage.setItem('playerShares', '1');
                        } else {
                            playerShares = '';
                        }
                        let membId = 0;
                        let sessionId = '';
                        if (DataString != null) {
                            membId = dataJson.MemberID;
                            sessionId = dataJson.sessionId;
                        } else {
                            membId = 0;
                            sessionId = '';
                        }
                        const paramsToSend = 'sessionId=' + sessionId + '&packageId=' + params['package']
                            + '&drawCount=' + 1 + playerShares + '&currency=' + this.currency;
                        this.lotteryService.postData(globals.appDomain +
                            '/cart/addSingleTicket/' + membId + '/addSingleTicket_nav.json',
                            paramsToSend)
                            .subscribe(
                                result => {
                                    const cartItem = result.addCartMessage;
                                    const thisCart = [];
                                    const lastItem = cartItem.Cart.Packages.pop();
                                    thisCart.push(lastItem);
                                    const storedCart = localStorage.getItem('cart');
                                    if (storedCart === null) {
                                        localStorage.setItem('cart', JSON.stringify(thisCart));
                                        this.cartService.updateCartLength();
                                    } else {
                                        const newStoredCart = JSON.parse(storedCart);
                                        newStoredCart.push(thisCart[0]);
                                        localStorage.setItem('cart', JSON.stringify(newStoredCart));
                                        this.cartService.updateCartLength();
                                    }
                                    url = url.indexOf('/') == 0 ? url.substring(1) : url;
                                    this.router.navigateByUrl('/' + this.language + '/' + url);
                                });
                    }
                });
        }

        if (params['incentiveId']) {
            const cookieIncentiveCodeExists: boolean = this.cookieService.check('incentiveCode');
            let incentiveCode;
            if (cookieIncentiveCodeExists) {
                incentiveCode = this.cookieService.get('incentiveCode');
            } else {
                incentiveCode = params['incentiveCode'];
            }
            const DataString = localStorage.getItem('playerDetails');
            const dataJson = JSON.parse(DataString);

            let url;
            const paramsUrl = this.actionService.checkParamsUrl(params['redirectUrl']);
            if (paramsUrl && paramsUrl.length > 1) {
                url = paramsUrl[0].toLowerCase();
                localStorage.setItem('dashboardStatus', paramsUrl[1].toLowerCase());
            } else {
                url = params['redirectUrl'] ? params['redirectUrl'].toLowerCase() : 'home';
            }
            // const url = params['redirectUrl'] ? params['redirectUrl'].toLowerCase() : 'home';

            let sendParams = 'incentiveId=' + params['incentiveId'];
            if (incentiveCode && incentiveCode !== 'undefined') {
                sendParams += '&cookieValue=' + incentiveCode;
            }
            const pickedNumbers = params['picked_numbers_id'];
            if (incentiveCode) {
                const incentive = localStorage.getItem('incentiveCodeCheckUp');
                localStorage.setItem('incentiveCodeCheckUp', incentiveCode);
                if (incentive !== incentiveCode) {
                    this.lotteryService.postData(
                        globals.appDomain + '/packages/getProductByIncentive/add.json', sendParams).subscribe(
                        result => {
                            if (result.status === 200) {
                                this.cartItem = [];
                                if (pickedNumbers) {
                                    this.lotteryService.getLotteries(globals.appDomain + '/draws/getNumbers/result.json?id=' + pickedNumbers)
                                        .subscribe(
                                            res => {
                                                const pickNumbers = [];
                                                let tempCartItem;
                                                tempCartItem = result.message;
                                                for (let i = 0; i < res.message[0].picks[0].length; i++) {
                                                    res.message[0].picks[0][i].base = res.message[0].picks[0][i].base
                                                        .replace('[', '').replace(']', '').split(',');
                                                    res.message[0].picks[0][i].extra = res.message[0].picks[0][i].extra
                                                        .replace('[', '').replace(']', '').split(',');
                                                    pickNumbers[i] = {};
                                                    pickNumbers[i] = {
                                                        'BasePick': res.message[0].picks[0][i].base,
                                                        'ExtraPick': res.message[0].picks[0][i].extra
                                                    };
                                                }
                                                tempCartItem.Items[0].PickedNumbers = [];
                                                tempCartItem.Items[0].PickedNumbers = pickNumbers;
                                                this.cartItem = tempCartItem;
                                                this.propagateCartAfterIncentive(params, url);
                                            }
                                        );
                                } else {
                                    this.cartItem = result.message;
                                    this.propagateCartAfterIncentive(params, url);
                                }
                            }
                        }, (err) => console.error(err));
                }
            }
        }
        if (params['init'] === 'lp') {
            const memberId = params['memberId'];
            const sessionId = params['sessionId'];

            if (localStorage.getItem('virtualLogin')) {
                this.virtualLogin = '&virtualLogin=' + localStorage.getItem('virtualLogin');
                this.subscriptionsService.emitVirtualLogin(this.virtualLogin);
            }

            const sendData = {};
            sendData['sessionId'] = sessionId;
            if (this.virtualLogin) {
                sendData['virtualLogin'] = this.virtualLogin.split('=')[1];
            }
            this.loginService
                .postData
                (globals.appDomain + '/user/details/' + memberId +
                    '/userDetails_nav_3.json', this.loginService.getFormUrlEncoded(sendData))
                .subscribe(
                    result => {
                        if (!result.message.ErrorID) {
                            localStorage.removeItem('playerDetails');
                            result.message.sessionId = sessionId;
                            result.message.memberId = memberId;
                            this.userBalance = result.message.TotalBalance;
                            this.subscriptionsService.updateBalance(result.message.TotalBalance);
                            this.userDataNameWithGender = {
                                FirstName: result.message.FirstName,
                                LastName: result.message.LastName,
                                Gender: result.message.Gender,
                            };
                            this.subscriptionsService.updateUserDataNameWithGender(this.userDataNameWithGender);

                            this.loggedIn = false;
                            this.subscriptionsService.emitIsLoggedIn(this.loggedIn);
                            localStorage.setItem('playerDetails', JSON.stringify(result.message));
                            this.loggedIn = true;
                            this.subscriptionsService.emitIsLoggedIn(this.loggedIn);

                            const sendDataCart = {};
                            sendDataCart['sessionId'] = result.message.sessionId;

                            this.lotteryService
                                .postData
                                (globals.appDomain + '/cart/get/'
                                    + result.message.memberId + '/cartGet_nav.json', this.loginService.getFormUrlEncoded(sendDataCart))
                                .subscribe(
                                    response => {
                                        if (response.message.Packages !== undefined) {
                                            localStorage.setItem('cart', JSON.stringify(response.message.Packages));
                                        }

                                        let url;
                                        const paramsUrl = this.actionService.checkParamsUrl(params['redirectUrl']);
                                        if (paramsUrl && paramsUrl.length > 1) {
                                            url = paramsUrl[0].toLowerCase();
                                            localStorage.setItem('dashboardStatus', paramsUrl[1].toLowerCase());
                                        } else {
                                            url = params['redirectUrl'] ? params['redirectUrl'].toLowerCase() : 'home';
                                        }


                                        if (params['redirectUrl']) {
                                            url = url.indexOf('/') == 0 ? url.substring(1) : url;
                                            this.router.navigateByUrl('/' + this.language + '/' + url);
                                        } else {
                                            this.router.navigate(['/']);
                                        }

                                        const DataString = localStorage.getItem('playerDetails');
                                        const DataJson = JSON.parse(DataString);
                                        const LanguageID = DataJson.LanguageID;
                                        if (LanguageID === 'de' || LanguageID === 'DE') {
                                            this.languageService.setLanguage(LanguageID);
                                        } else {
                                            this.translate.use('en');
                                            this.language = 'en';
                                            localStorage.setItem('pageLanguage', 'en');
                                        }
                                    }
                                );
                            this.subscriptionsService.emitChangeCurrency(result.message.Currency);
                        }
                    }
                );
        }
        if (params['Lang'] || params['lang']) {
            let lang = '';
            if (params['Lang']) {
                lang = params['Lang'].toLowerCase();
            } else {
                lang = params['lang'].toLowerCase();
            }
            this.translate.use(lang);
            this.language = lang;
            localStorage.setItem('pageLanguage', lang);
            // this.location.replaceState(this.location.path().replace('Lang=' + lang || 'lang=' + lang, ''));
            this.subscriptionsService.emitLanguage(lang);
        }
        if (params['init'] === 'email') {
            if (params['utm_campaign'] === 'purchase success') {
                localStorage.setItem('dashboardStatus', 'my-entries');
            }
            this.timeZone = this.timeService.getTimezone();
            let url = '';
            const paramsUrl = this.actionService.checkParamsUrl(params['redirectUrl']);
            if (paramsUrl && paramsUrl.length > 1) {
                url = paramsUrl[0].toLowerCase();
                localStorage.setItem('dashboardStatus', paramsUrl[1].toLowerCase());
            } else {
                url = params['redirectUrl'] ? params['redirectUrl'].toLowerCase() : 'home';
            }
            this.timeZone = this.timeService.getTimezone();
            let paramsToSend = 'email=' + params['email'] + '&password=' + params['email_token'];
            if (params['incentiveCode'] && params['incentiveCode'] !== 'undefined') {
                paramsToSend += '&cookieValue=' + params['incentiveCode'];
            }
            localStorage.removeItem('virtualLogin');
            this.loginService
                .logIn(globals.appDomain + '/user/login/userLogin_nav_3.json', paramsToSend)
                .subscribe(
                    data => {
                        const sendData = {};
                        sendData['sessionId'] = data.message.SessionID;
                        sendData['timeZone'] = this.timeZone;
                        localStorage.setItem('knownUser', 'true');
                        this.subscriptionsService.emitFreshLogin(true);

                        this.loginService
                            .postData
                            (globals.appDomain + '/user/details/' + data.message.MemberID +
                                '/userDetails_nav_4.json', this.loginService.getFormUrlEncoded(sendData))
                            .subscribe(
                                result => {
                                    localStorage.removeItem('playerDetails');
                                    result.message.sessionId = data.message.SessionID;
                                    result.message.memberId = data.message.MemberID;
                                    this.userBalance = result.message.TotalBalance;
                                    this.subscriptionsService.updateBalance(result.message.TotalBalance);
                                    this.userDataNameWithGender = {
                                        FirstName: result.message.FirstName,
                                        LastName: result.message.LastName,
                                        Gender: result.message.Gender,
                                    };
                                    this.subscriptionsService.updateUserDataNameWithGender({
                                        FirstName: result.message.FirstName,
                                        LastName: result.message.LastName,
                                        Gender: result.message.Gender
                                    });
                                    this.loggedIn = false;
                                    this.subscriptionsService.emitIsLoggedIn(this.loggedIn);
                                    const ln = params['Lang'] ? params['Lang'].toLowerCase() : result.message.LanguageID;
                                    this.languageService.setLanguage(ln);
                                    localStorage.setItem('playerDetails', JSON.stringify(result.message));
                                    this.loggedIn = true;
                                    this.subscriptionsService.emitIsLoggedIn(this.loggedIn);
                                    setTimeout(() => {
                                        url = url.indexOf('/') == 0 ? url.substring(1) : url;
                                        this.router.navigateByUrl('/' + this.language + '/' + url);
                                        if (params['action'] === 'deposit') {
                                            setTimeout(() => {
                                                this.subscriptionsService.triggerDepositService(true);
                                            });
                                        }
                                    }, 1000);
                                    this.subscriptionsService.emitChangeCurrency(result.message.Currency);
                                    this.getpmService.getPaymentMethods();
                                }
                            );
                    }
                );
        }
        if (params['init'] === 'unsubscribe') {
            const paramToSend = 'email=' + params['email'] + '&emailToken=' + params['email_token'] + '&status=0';
            localStorage.setItem('unsubscribe', paramToSend);
            this.router.navigate(['/' + this.language, 'unsubscribe']);
        }
        if (params['init'] === 'reset' && params['action'] === 'changePassword') {
            this.resetToken = params['token'];
            this.subscriptionsService.emitResetToken(this.resetToken);
            this.resetEmail = params['email'];
            this.subscriptionsService.emitResetEmail(this.resetEmail);
            this.resetPassword = !this.resetPassword;
            this.subscriptionsService.emitResetPassword(this.resetPassword);
            this.modalSize = 'modal-md';
            this.subscriptionsService.emitModalSize(this.modalSize);
        }
        if (params['init'] === 'reset' && params['action'] === 'resetPassword') {
            this.resetToken = params['token'];
            this.subscriptionsService.emitResetToken(this.resetToken);
            this.resetEmail = params['email'];
            this.subscriptionsService.emitResetEmail(this.resetEmail);
            this.showForgetPassword = !this.showForgetPassword;
            this.subscriptionsService.emitShowForgetPassword(this.showForgetPassword);
            this.modalSize = 'modal-md';
            this.subscriptionsService.emitModalSize(this.modalSize);
        }
        if (params['virtualSessionID']) {
            localStorage.clear();
            localStorage.setItem('virtualLogin', '1');
            this.userService.getUserDetails(params['virtualSessionID'], params['memberId'], true);
            this.loggedIn = true;
            this.subscriptionsService.emitIsLoggedIn(this.loggedIn);
        }
        if (params['package'] && params['email'] && params['email_token']) {
            let playerShares;
            if (params['teamplayPackage']) {
                playerShares = '&playerShares=' + 1;
                localStorage.setItem('playerShares', '1');
            } else {
                playerShares = '';
            }
            this.timeZone = this.timeService.getTimezone();
            let url = '';
            const paramsUrl = this.actionService.checkParamsUrl(params['redirectUrl']);
            if (paramsUrl && paramsUrl.length > 1) {
                url = paramsUrl[0].toLowerCase();
                localStorage.setItem('dashboardStatus', paramsUrl[1].toLowerCase());
            } else {
                url = params['redirectUrl'] ? params['redirectUrl'].toLowerCase() : 'home';
            }
            this.timeZone = this.timeService.getTimezone();
            const paramsToSend = 'email=' + params['email'] + '&password=' + params['email_token'];
            this.loginService
                .logIn(globals.appDomain + '/user/login/userLogin_nav_4.json', paramsToSend)
                .subscribe(
                    data => {

                        const sendData = {};
                        sendData['sessionId'] = data.message.SessionID;
                        sendData['timeZone'] = this.timeZone;
                        localStorage.setItem('knownUser', 'true');
                        this.subscriptionsService.emitFreshLogin(true);

                        this.loginService
                            .postData
                            (globals.appDomain + '/user/details/' + data.message.MemberID +
                                '/userDetails_nav_5.json', this.loginService.getFormUrlEncoded(sendData))
                            .subscribe(
                                result => {
                                    localStorage.removeItem('playerDetails');
                                    result.message.sessionId = data.message.SessionID;
                                    result.message.memberId = data.message.MemberID;
                                    this.userBalance = data.message.TotalBalance;
                                    this.subscriptionsService.updateBalance(data.message.TotalBalance);
                                    this.userDataNameWithGender = {
                                        FirstName: data.message.FirstName,
                                        LastName: data.message.LastName,
                                        Gender: data.message.Gender,
                                    };
                                    this.subscriptionsService.updateUserDataNameWithGender(this.userDataNameWithGender);
                                    this.loggedIn = false;
                                    this.subscriptionsService.emitIsLoggedIn(this.loggedIn);
                                    this.languageService.setLanguage(result.message.LanguageID);
                                    localStorage.setItem('playerDetails', JSON.stringify(result.message));
                                    this.loggedIn = true;
                                    this.subscriptionsService.emitIsLoggedIn(this.loggedIn);
                                    let isGamePackage = false;
                                    let ticketsDefault;

                                    this.lotteryService.getLotteries(
                                        globals.appDomain + '/ScratchCards/getGamePackages/getGamePackages.json').subscribe(
                                        result2 => {
                                            if (result2) {
                                                for (let i = 0; i < result2.length; i++) {
                                                    if (result2[i].PackageID === params['package']) {
                                                        isGamePackage = true;
                                                        ticketsDefault = result2[i].ProductType !== 'bundle' ? result2[i].PackageMultiTickets[1].Tickets : 1;
                                                    }
                                                }
                                            }
                                        }, (err) => console.error(err),
                                        () => {
                                            if (isGamePackage) {
                                                const userDataString = localStorage.getItem('playerDetails');
                                                const userDataJson = JSON.parse(userDataString);
                                                let memberId = '0';
                                                if (userDataJson) {
                                                    memberId = userDataJson.MemberID;
                                                }
                                                const packageId = params['package'];
                                                const ticketsCount = params['tickets'] ? params['tickets'] : ticketsDefault;
                                                this.packageId = packageId;
                                                this.ticketAmount = ticketsCount;
                                                let cartToSend = 'packageId=' + packageId + '&ticketsCount=' + ticketsCount;
                                                if (userDataJson && userDataJson.sessionId) {
                                                    cartToSend += '&sessionId=' + userDataJson.sessionId + '&sessionCart=0';
                                                } else {
                                                    cartToSend += '&sessionId=' + '&sessionCart=0';
                                                }
                                                cartToSend += '&currency=' + this.currency.Code;
                                                this.lotteryService
                                                    .postData(globals.appDomain + '/cart/addSingleTicket/' +
                                                        memberId + '/cartAddSingleTicket_scratchcard.json', cartToSend)
                                                    .subscribe(
                                                        resp => {
                                                            if (!resp.addCartMessage.ErrorID && resp.addCartMessage) {
                                                                localStorage.setItem('cart', JSON.stringify(resp.addCartMessage.Cart.Packages));
                                                                const cart2 = resp.addCartMessage.Cart.Packages;
                                                                this.subscriptionsService.updateCartItems(cart2);

                                                                url = url.indexOf('/') == 0 ? url.substring(1) : url;
                                                                this.router.navigateByUrl('/' + this.language + '/' + url);

                                                            }
                                                        }
                                                    );

                                            } else {
                                                const paramsSend = 'sessionId=' + data.message.SessionID +
                                                    '&packageId=' + params['package'] +
                                                    '&drawCount=' + 1 + playerShares + '&currency=' + this.currency;
                                                this.lotteryService.postData(globals.appDomain +
                                                    '/cart/addSingleTicket/' + data.message.MemberID +
                                                    '/addSingleTicket_nav.json', paramsSend)
                                                    .subscribe(
                                                        res => {
                                                            const cartItem = res.addCartMessage;
                                                            const thisCart = [];
                                                            const lastItem = cartItem.Cart.Packages.pop();
                                                            thisCart.push(lastItem);
                                                            const storedCart = localStorage.getItem('cart');
                                                            if (storedCart === null) {
                                                                localStorage.setItem('cart', JSON.stringify(thisCart));
                                                                this.cartService.updateCartLength();
                                                            } else {
                                                                const newStoredCart = JSON.parse(storedCart);
                                                                newStoredCart.push(thisCart[0]);
                                                                localStorage.setItem('cart', JSON.stringify(newStoredCart));
                                                                this.cartService.updateCartLength();
                                                            }
                                                            url = url.indexOf('/') == 0 ? url.substring(1) : url;
                                                            this.router.navigateByUrl('/' + this.language + '/' + url);

                                                        });
                                            }
                                        });
                                    this.subscriptionsService.emitChangeCurrency(result.message.Currency);
                                }
                            );
                    }
                );
        }
    }

    propagateCartAfterIncentive(params, url) {
        const DataString = localStorage.getItem('playerDetails');
        const dataJson = JSON.parse(DataString);
        const thisCart = [];
        thisCart.push(this.cartItem);
        const storedCart = localStorage.getItem('cart');
        if (storedCart === null) {
            localStorage.setItem('cart', JSON.stringify(thisCart));
            this.cartService.updateCartLength();
            if (dataJson) {
                this.cantRedirect = true;
                this.sendCart(dataJson);
            }
        } else {
            const newStoredCart = JSON.parse(storedCart);
            newStoredCart.push(thisCart[0]);
            localStorage.setItem('cart', JSON.stringify(newStoredCart));
            this.cartService.updateCartLength();
            if (dataJson) {
                this.cantRedirect = true;
                this.sendCart(dataJson);
            }
        }
        this.redirectMe(params, url);
    }

    sendCart(dataJson) {
        const cart = JSON.parse(localStorage.getItem(('cart')));
        let cartToSend = '';
        const playerShares = localStorage.getItem('playerShares') === '1' ? '&playerShares=' + 1 : '';

        cartToSend += '&sessionId=' + dataJson.sessionId;
        cartToSend += '&sessionCart=1' + playerShares;
        for (const x of Object.keys(cart)) {
            cartToSend += '&packageId[' + x + ']=' + cart[x].PackageID;
            cartToSend += '&lotteryId[' + x + ']=' + cart[x].Items[0].LotteryID;
            cartToSend += '&billingPeriod[' + x + ']=1';
            cartToSend += '&isSubscription[' + x + ']=0';
            cartToSend += '&drawCount[' + x + ']=' + cart[x].DrawCount;
            for (const i of Object.keys(cart[x].Items)) {
                if (cart[x].ProductSubType === 'lotteries') {
                    for (const z of Object.keys(cart[x].Items[i].PickedNumbers)) {
                        cartToSend
                            += '&base[' + x + '][]='
                            + JSON.stringify(cart[x].Items[i].PickedNumbers[z].BasePick);
                        cartToSend
                            += '&extra[' + x + '][]='
                            + JSON.stringify(cart[x].Items[i].PickedNumbers[z].ExtraPick);
                    }
                }
            }
        }
        cartToSend += '&currency=' + this.currency;
        this.lotteryService
            .postData(globals.appDomain + '/cart/addSingleTicket/' +
                dataJson.memberId + '/cartAddSingleTicket_Param_service.json', cartToSend)
            .subscribe(
                resp => {
                    if (resp.addCartMessage.ErrorID === undefined) {
                        localStorage.setItem
                        ('cart', JSON.stringify(resp.addCartMessage.Cart.Packages));
                        this.cantRedirect = false;
                    }
                }
            );
    }

    redirectMe(params, url) {
        if (!this.cantRedirect) {
            if (params['redirectUrl'] && params['redirectUrl'].split('/')[0] && params['redirectUrl'].split('/')[1]) {
                this.redirectMe(params, url);

                this.router.navigate(['/' + this.language,
                    params['redirectUrl'].split('/')[0], params['redirectUrl'].split('/')[1]]);
            } else {
                this.router.navigate(['/' + this.language, url]);

            }
        } else {
            setTimeout(() => {
                this.redirectMe(params, url);
            }, 500);
        }
    }
}
